import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ExtranetService } from './extranet.service';

@Injectable()
export class NotesService {

  constructor(private apiService: ApiService, private extranetService: ExtranetService) {}

  /**
   * Save notes
   * @param oid
   * @param category
   * @param note
   */
  save(oid: string, category: string, note: string): Observable<any> {
    let body: any = {oid, category, note};
    if (this.extranetService.getSupportUser()) {
      body = {oid, category, note, extranetToken: this.extranetService.getSupportUser().token};
    }
    return this.apiService.post('extranet/notes', body);
  }
}
